import React, { Component } from "react";
import { Layout } from "antd";
import QueueAnim from "rc-queue-anim";

import loginHero from "../images/login-hero.jpg";

class loginTemplate extends Component {
	render() {
		return (
			<Layout className="template-login">
				<QueueAnim className="auth-split" type="alpha">
					<div className="auth-split__left" key="left">
						{this.props.children}
					</div>
					<div className="auth-split__right" key="right">
						<img
							className="auth-split__hero"
							src={loginHero}
							alt="Gestão inteligente. Direto ao Ponto. — painel do ByPonto"
						/>
					</div>
      	</QueueAnim>				
			</Layout>
		)
	}
}

export default loginTemplate;
